// flagMap.js

const flagMap = {
    ae: require('./ae.png'),
    bs: require('./bs.png'),
    pa: require('./pa.png'),
    dk: require('./dk.png'),
    lr: require('./lr.png'),
    us: require('./us.png'),
    gb: require('./gb.png'),
    it: require('./it.png'),
    sg: require('./sg.png'),
    kr: require('./kr.png'),
    cn: require('./cn.png'),
    br: require('./br.png'),
    me: require('./me.png'),
    fr: require('./fr.png'),
    hk: require('./hk.png'),
    in: require('./in.png'),
    om: require('./om.png'),
    pk: require('./pk.png'),
    qa: require('./qa.png'),
    bh: require('./bh.png'),
    kw: require('./kw.png'),
    sa: require('./sa.png'),
    de: require('./de.png'),
    es: require('./es.png'),
    pt: require('./pt.png'),
    tr: require('./tr.png'),
    gr: require('./gr.png'),
    pl: require('./pl.png'),
    ua: require('./ua.png'),
    ru: require('./ru.png'),
    za: require('./za.png'),
    ir: require('./ir.png'),
    iq: require('./iq.png'),
    ye: require('./ye.png'),
    jp: require('./jp.png'),
    nl: require('./nl.png'),
    default: require('./default.png'),
};

export default flagMap;
